import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, SalesItemOptionModel } from '.';

export interface ISalesItemRebateSalesItemModel extends IModel {
  salesItemRebateSalesItemId: number;
  salesItemId: number;
  rebateSalesItemOptionId: number;
  rebateSalesItemOption: SalesItemOptionModel | undefined;
  rebateSalesItemOptionFullName: string;
}

export class SalesItemRebateSalesItemModel
  extends Model
  implements ModelRecord<ISalesItemRebateSalesItemModel>
{
  salesItemRebateSalesItemId: number;
  salesItemId: number;
  rebateSalesItemOptionId: number;
  rebateSalesItemOption: SalesItemOptionModel | undefined;
  rebateSalesItemOptionFullName: string;

  constructor(params?: Partial<ISalesItemRebateSalesItemModel>) {
    super(params);
    this.salesItemRebateSalesItemId = defaultTo(
      params?.salesItemRebateSalesItemId,
      0,
    );
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.rebateSalesItemOptionId = defaultTo(
      params?.rebateSalesItemOptionId,
      0,
    );
    this.rebateSalesItemOption = params?.rebateSalesItemOption
      ? new SalesItemOptionModel(params?.rebateSalesItemOption)
      : undefined;
    this.rebateSalesItemOptionFullName = defaultTo(
      params?.rebateSalesItemOptionFullName,
      '',
    );
  }
}
